import { render, staticRenderFns } from "./MovePrograms.vue?vue&type=template&id=373b40f9&scoped=true&"
import script from "./MovePrograms.vue?vue&type=script&lang=js&"
export * from "./MovePrograms.vue?vue&type=script&lang=js&"
import style0 from "./MovePrograms.vue?vue&type=style&index=0&id=373b40f9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "373b40f9",
  null
  
)

export default component.exports